import * as firebase from 'firebase'
import { Store } from 'vuex';

export default {
  state: {
    loadedSchedules: [],
    createdKey: null

  },
  mutations: {
    setCurrentSchedule(state, payload) {
      state.createdKey = payload

    },
    setLoadedSchedules(state, payload) {
      state.loadedSchedules = payload
    },
    createSchedule(state, payload) {
      state.loadedSchedules.push(payload)
      state.createdKey = payload.id

    },
    deleteSchedule(state, payload) {
      for (var i = state.loadedSchedules.length - 1; i >= 0; --i) {
        if (state.loadedSchedules[i].id == payload) {
          state.loadedSchedules.splice(i, 1);
        }
      }
    },
    updateSchedule(state, payload) {
      console.log("MUTATIONS", payload)
      const schedule = state.loadedSchedules.find(schedule => {
        return schedule.id === payload.id
      })
      if (payload.name) {
        schedule.title = payload.name
      }
      if (payload.description) {
        schedule.description = payload.description
      }
      if (payload.date) {
        schedule.date = payload.date
      }
      if (payload.description) {
        schedule.description = payload.description
      }
      if (payload.duration) {
        schedule.duration = payload.duration
      }
      if (payload.items) {
        schedule.items = payload.items
      }

      if (payload.color) {
        schedule.color = payload.color
      }
      if (payload.startDate) {
        schedule.startDate = payload.startDate
      }
      if (payload.startTime) {
        schedule.startTime = payload.startTime
      }
      if (payload.endTime) {
        schedule.endTime = payload.endTime
      }
      if (payload.hideTime) {
        schedule.hideTime = payload.hideTime
      }
      if (payload.expandPlaylist) {
        schedule.expandPlaylist = payload.expandPlaylist
      }
    }
  },
  actions: {
    loadTextSchedule({ commit }) {
      commit('setLoading', true)
      firebase
        .database()
        .ref('schedule')
        .once('value')
        .then(data => {
          console.log(data)
          commit('setLoading', false)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
    },
    loadSchedules({ commit }) {
      commit('setLoading', true)
      firebase
        .database()
        .ref('schedule')
        .once('value')
        .then(data => {
          const schedules = []
          const obj = data.val()
          for (let key in obj) {
            schedules.push({
              id: key,
              title: obj[key].title,
              description: obj[key].description,
              duration: obj[key].duration,
              videoUrl: obj[key].videoUrl,
              imageUrl: obj[key].imageUrl,
              color: obj[key].color,
              web: obj[key].web,
              items: obj[key].items,
              hideS: obj[key].hideS,
              date: obj[key].date,
              creatorId: obj[key].creatorId,
              startTime: obj[key].startTime,
              startDate: obj[key].startDate,
              hideTime: obj[key].hideTime || false,
              expandPlaylist: obj[key].expandPlaylist || false
            })
          }
          commit('setLoading', false)
          commit('setLoadedSchedules', schedules)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
    },
    createSchedule({ commit, dispatch, getters }, payload) {
      console.log("createSchedule", payload);
      var store = this;
      let key
      const schedule = {
        title: payload.name,
        items: payload.items,
        duration: payload.duration || 0,
        color: payload.color,
        creatorId: getters.user.id,
        startDate: payload.startDate,
        startTime: payload.startTime,
        hideTime: payload.hideTime || false,
        expandPlaylist: payload.expandPlaylist || false
      }
      console.log("createSchedule", schedule);
      // Reach out to firebase and store it
      firebase
        .database()
        .ref('schedule')
        .push(schedule)
        .then(data => {
          console.log(data)
          key = data.key
          return key
        })
        .then(key => {
          console.log("SUBMITTED SCHEDULE")
          commit('createSchedule', {
            ...schedule,
            id: key
          })
          commit('setCurrentSchedule', schedule)
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteSchedule({ commit }, payload) {
      firebase
        .database()
        .ref('schedule')
        .child(payload)
        .remove()
        .then(() => {
          commit('deleteSchedule', payload)
        })
    },
    updateScheduleData({ commit }, payload) {
      commit('setLoading', true)
      console.log("updateScheduleData", payload)
      const updateObj = {}
      if (payload.name) {
        updateObj.title = payload.name
      }
      if (payload.description) {
        updateObj.description = payload.description
      }
      if (payload.duration) {
        updateObj.duration = payload.duration
      }
      if (payload.items) {
        updateObj.items = payload.items
      }
      if (payload.date) {
        updateObj.date = payload.date
      }
      if (payload.color) {
        updateObj.color = payload.color
      }
      if (payload.startDate) {
        updateObj.startDate = payload.startDate
      }
      if (payload.startTime) {
        updateObj.startTime = payload.startTime
      }
      if (payload.endTime) {
        updateObj.endTime = payload.endTime
      }
      if (payload.hideTime) {
        updateObj.hideTime = payload.hideTime
      }
      if (payload.expandPlaylist) {
        updateObj.expandPlaylist = payload.expandPlaylist
      }
      console.log("updateScheduleData2", updateObj)
      firebase
        .database()
        .ref('schedule')
        .child(payload.id)
        .update(updateObj)
        .then(() => {
          commit('setLoading', false)
          commit('updateSchedule', payload)
        })
        .catch(error => {
          commit('setLoading', false)
          console.log(error)
        })
    }
  },
  getters: {
    createdKey(state) {
      return state.createdKey;
    },
    loadedSchedules(state) {
      return state.loadedSchedules.sort((scheduleA, scheduleB) => {
        return scheduleA.date > scheduleB.date
      })
    },
    loadedSchedule(state) {
      return scheduleId => {
        return state.loadedSchedules.find(schedule => {
          return schedule.id === scheduleId
        })
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/schedule/index.js